import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as mobileUpdateActions from 'action/mobileUpdate'
import { isEmpty } from 'utils/validations'
import ContentHeader from 'component/utils/ContentHeader'
import MobileUpdateTable from 'component/mobileUpdate/Table'
import MobileUpdateEditForm from 'component/mobileUpdate/EditForm'
import Notification from 'component/utils/Notification'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import Breadcrumb from 'component/Breadcrumb'

class MobileUpdateContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    removed: PropTypes.bool,
    mobileUpdates: PropTypes.array.isRequired,
    update: PropTypes.func.isRequired,
    fetchMobileUpdates: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      formVisible: true,
      tableVisible: true,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.delMobileUpdate = this.delMobileUpdate.bind(this)
    this.handleFetchMobileUpdate = this.handleFetchMobileUpdate.bind(this)
    this.renderNotification = this.renderNotification.bind(this)
    this.renderUpdateNotification = this.renderUpdateNotification.bind(this)
    this.invertStates = this.invertStates.bind(this)
  }

  componentWillMount() {
    if (window.innerWidth <= 768) {
      this.setState({ formVisible: false })
    } else {
      this.setState({ formVisible: true })
      this.setState({ tableVisible: true })
    }
  }

  componentDidMount() {
    const {
      fetchMobileUpdates,
      auth: { user },
    } = this.props

    fetchMobileUpdates(user.dsToken)
  }

  componentWillReceiveProps() {
    const { formVisible } = this.state
    const { updated } = this.props

    if (formVisible && updated) {
      this.invertStates()
    }
  }

  invertStates() {
    if (window.innerWidth > 768) {
      this.setState({ formVisible: true })
      this.setState({ tableVisible: true })
      return
    }

    let { formVisible, tableVisible } = this.state

    formVisible = !formVisible
    tableVisible = !tableVisible

    this.setState({ formVisible })
    this.setState({ tableVisible })
  }

  handleFetchMobileUpdate(page) {
    const {
      fetchMobileUpdates,
      auth: { user },
    } = this.props

    fetchMobileUpdates(user.dsToken, page)
  }

  handleSubmit(toSave) {
    const {
      update,
      auth: { user },
    } = this.props

    update(user.dsToken, toSave)
  }

  delMobileUpdate(toRemove) {
    const {
      remove,
      auth: { user },
    } = this.props

    remove(user.dsToken, toRemove)
  }

  renderNotification() {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('mobile-update.not-found')}
      />
    )
  }

  renderUpdateNotification() {
    const { translate } = this.props

    return (
      <Notification
        className='notification-success margin-top'
        message={translate('mobile-update.update-success')}
      />
    )
  }

  renderRemoveNotification() {
    const { translate } = this.props

    return (
      <Notification
        className='notification-success margin-top'
        message={translate('mobile-update.remove-success')}
      />
    )
  }

  renderFieldsErrors = (fields) => (
    <li className='margin-left' key={fields.naField}>
      {fields.naField ? `${fields.naField}:` : ''} {fields.dsDetail}
    </li>
  )

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile-update.updates') },
      { title: translate('mobile-update.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const {
      translate,
      error,
      mobileUpdates,
      pages,
      count,
      current,
      updated,
      removed,
      auth,
    } = this.props

    const { tableVisible, formVisible } = this.state

    const initialValues = {}

    return (
      <section>
        <ContentHeader>{translate('mobile-update.title')}</ContentHeader>

        <section>
          {this.renderBreadcrumb()}

          <div className='container-fluid'>
            {
              // shows notification after an update
              error && error.fields ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.fields.map(this.renderFieldsErrors)}
                </div>
              ) : error ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.message.dsMessage}
                </div>
              ) : (
                ''
              )
            }
          </div>

          <Row className='container-mobile container-flex'>
            {formVisible && (
              <Col xs={12} sm={12} md={3} className='show-fourth-on-mobile'>
                <MobileUpdateEditForm
                  translate={translate}
                  onSubmit={this.handleSubmit}
                  initialValues={initialValues}
                  error={error}
                  auth={auth}
                  invertStates={this.invertStates}
                />
              </Col>
            )}

            {tableVisible && (
              <Col xs={12} sm={12} md={9} className='show-first-on-mobile'>
                {updated && this.renderUpdateNotification()}
                {removed && this.renderRemoveNotification()}

                {isEmpty(mobileUpdates) ? (
                  this.renderNotification()
                ) : (
                  <MobileUpdateTable
                    translate={translate}
                    mobileUpdates={mobileUpdates}
                    delMobileUpdate={this.delMobileUpdate}
                    onSubmit={this.handleSubmit}
                    user={auth.user}
                  />
                )}
              </Col>
            )}

            {pages > 1 && tableVisible && (
              <Col className='show-second-on-mobile align-center margin-top margin-bottom-double'>
                <div className='align-center'>
                  <Pagination
                    getPage={this.handleFetchMobileUpdate}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                </div>
              </Col>
            )}
          </Row>
        </section>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = ({ mobileUpdateReducer, paginateReducer }) => ({
  mobileUpdates: mobileUpdateReducer.list.records,
  updated: mobileUpdateReducer.edit.updated,
  removed: mobileUpdateReducer.edit.removed,
  error: mobileUpdateReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(mobileUpdateActions, dispatch)

/*
 * Connects component to I18next
 */
const MobileUpdateTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(MobileUpdateContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileUpdateTranslated)

/*
 * Exports as component
 */
export { MobileUpdateContainer as MobileUpdate }
